package com.kinoshazam.screens.decide

expect fun currentWebOrigin(): String?

expect fun consumeJoinUrlFromBrowser()

private const val PUBLIC_WEB_ORIGIN = "https://kinoshka.net"

fun partyShareUrl(code: String, serverInviteUrl: String?): String {
    val trimmed = code.trim().uppercase()
    if (trimmed.isEmpty()) return ""
    currentWebOrigin()?.let { origin -> return "$origin/join/$trimmed" }
    val fromServer = serverInviteUrl?.trim()?.takeIf { it.isNotBlank() }
    if (fromServer != null && isPublicWebJoinUrl(fromServer)) return fromServer
    return "$PUBLIC_WEB_ORIGIN/join/$trimmed"
}

private fun isPublicWebJoinUrl(url: String): Boolean {
    val lower = url.lowercase()
    if ("api.kinoshka.net" in lower) return false
    if ("localhost" in lower || "127.0.0.1" in lower || "10.0.2.2" in lower) return false
    return "kinoshka.net" in lower && "/join/" in lower
}
